document.addEventListener('DOMContentLoaded', function() {
  addStickyClassHeaderScroll();
	toggleMobileMenu();
	handleAnnouncementBar();
});

/*
 * Add class to header when it becomes sticky
 */
function addStickyClassHeaderScroll() {
	var header = document.getElementById("header");
	var sticky = header.offsetTop;

	function handleScroll() {
		if (window.scrollY > sticky) {
			header.classList.add("sticky");
		} else {
			header.classList.remove("sticky");
		}
	}

	window.addEventListener("scroll", handleScroll);
}

/*
 * Mobile menu toggle
 */
function toggleMobileMenu() {
  const menuItemsWithSubmenu = document.querySelectorAll('.menu-item-has-children > a');
  const icon = document.querySelector('.menu-desktop .nav-icon');
  const menuIcon = document.querySelector('.menu-desktop .icon-menu');
  const closeIcon = document.querySelector('.menu-desktop .icon-close');
  const menuItemHasChildrenList = document.querySelectorAll('.menu-drawer .menu-mobile .menu-item-has-children');
  const header = document.querySelector('header');
  
  closeIcon.classList.add('hide');

  menuItemsWithSubmenu.forEach(function(item) {
    item.addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the default navigation behavior
    });
  });
  
  icon.addEventListener('click', function() {
    if (header.classList.contains('menu-modal-open')) {
      header.classList.remove('menu-modal-open');
      menuIcon.classList.remove('hide');
      closeIcon.classList.add('hide');
    } else {
      header.classList.add('menu-modal-open');
      menuIcon.classList.add('hide');
      closeIcon.classList.remove('hide');
    }
  });
  
  // Add event listener for the close icon
  closeIcon.addEventListener('click', function() {
    header.classList.remove('menu-modal-open');
    menuIcon.classList.remove('hide');
    closeIcon.classList.add('hide');
  });
  
  menuItemHasChildrenList.forEach(menuItemHasChildren => {
    menuItemHasChildren.addEventListener('click', function() {
      if (menuItemHasChildren.classList.contains('display-submenu')) {
        menuItemHasChildren.classList.remove('display-submenu');
      } else {
        menuItemHasChildren.classList.add('display-submenu');
      }
    });
  });
  
}

/*
 * Announcement bar
 */
function handleAnnouncementBar() {
  function removeAnnouncementBar() {
    // Remove the ".announcement-bar" element from the DOM
    var announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      announcementBar.remove();
    }

    // Set a cookie to prevent the announcement bar from showing again for 1 day
    var expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 1); // Set expiry date to 1 day ahead
    document.cookie = 'hideAnnouncementBar=true; expires=' + expiryDate.toUTCString() + '; path=/';
  }

  function getCookie(name) {
    var value = '; ' + document.cookie;
    var parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  // Check if the cookie exists and hide the announcement bar if necessary
  var hideAnnouncementBar = getCookie('hideAnnouncementBar');
  if (hideAnnouncementBar === 'true') {
    removeAnnouncementBar();
  }

  // Add an event listener to the ".icon-close" element to trigger the removal when clicked
  var closeButton = document.querySelector('.icon-close');
  if (closeButton) {
    closeButton.addEventListener('click', function() {
      removeAnnouncementBar();
    });
  }
}

/*
 * Swiper: Testimonials
 */
const swiperTestimonial = new Swiper('.swiper-testimonial', {
  autoHeight: true,
  direction: 'horizontal',
  loop: false,
  keyboard: true,

  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

/*
 * Swiper: Benefits cards
 */
const swiperBenefitCards = new Swiper('.swiper-benefit-cards', {
  direction: 'horizontal',
  slidesPerView: 2,
  spaceBetween: 8,
  slidesOffsetAfter: 16,
  slidesOffsetBefore: 16,
  grabCursor: true,
  mousewheel: true,
  freeMode: true,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 16,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 16,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 16,
      slidesOffsetAfter: 24,
      slidesOffsetBefore: 24,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 16,
      slidesOffsetAfter: 40,
      slidesOffsetBefore: 40,
    },
    1440: {
      slidesPerView: 5,
      spaceBetween: 16,
      slidesOffsetAfter: 120,
      slidesOffsetBefore: 120,
    },
    1600: {
      slidesPerView: 6,
      spaceBetween: 16,
      slidesOffsetAfter: 200,
      slidesOffsetBefore: 200,
    },
    1920: {
      slidesPerView: 6,
      spaceBetween: 16,
      slidesOffsetAfter: 360,
      slidesOffsetBefore: 360,
    },
  },
});

/*
 * Tabbed interface
 */
function openTab(tabName) {
  // Hide all tab content
  const tabContents = document.getElementsByClassName("tab-content");
  for (let i = 0; i < tabContents.length; i++) {
    tabContents[i].style.display = "none";
  }

  // Deactivate all tab buttons
  const tabButtons = document.getElementsByClassName("tab-button");
  for (let i = 0; i < tabButtons.length; i++) {
    tabButtons[i].classList.remove("active");
  }

  // Show the selected tab content and activate the corresponding tab button
  const selectedTabContent = document.getElementById(tabName);
  const selectedTabButton = document.querySelector(`[onclick="openTab('${tabName}')"]`);
  selectedTabContent.style.display = "block";
  selectedTabButton.classList.add("active");
}

/*
 * Partner & Labs: Lightbox
 */
$(document).ready(function() {
  let currentIndex = 0;
  const items = $('.partner-labs-block');
  const itemCount = items.length;

  function showItem(index) {
    const currentItem = items.eq(index);
    const imgSrc = currentItem.find('.partner-labs--logo img').attr('src');
    const testList = currentItem.find('.partner-labs--list').html();
    const linkSrc = currentItem.find('.button').attr('href');

    $('#lightbox-content .partner-labs--logo img').attr('src', imgSrc);
    $('#lightbox-content .partner-labs--list').html(testList);
    $('#lightbox-content .button').attr('href', linkSrc);
  }

  function closeLightbox() {
    $('#lightbox-container').fadeOut();

    // Remove the class from the previously clicked item and the lightbox container
    $('.modal-open').removeClass('modal-open');
    $('.lightbox-container.modal-open').removeClass('lightbox-container.modal-open');
  }

  $('.partner-labs-block').on('click', function() {
    currentIndex = $(this).data('index') - 1;
    showItem(currentIndex);
    $('#lightbox-container').fadeIn();

    $(this).addClass('modal-open')
    $('.lightbox-container').addClass('modal-open');
  });

  $('#lightbox-close').on('click', closeLightbox);

  $('#carousel-prev').on('click', function() {
    currentIndex = (currentIndex - 1 + itemCount) % itemCount;
    showItem(currentIndex);
  });

  $('#carousel-next').on('click', function() {
    currentIndex = (currentIndex + 1) % itemCount;
    showItem(currentIndex);
  });

  $(document).on('keydown', function(e) {
    if ($('.lightbox-container').hasClass('modal-open')) {
      if (e.keyCode === 37) { // Left arrow key
        currentIndex = (currentIndex - 1 + itemCount) % itemCount;
        showItem(currentIndex);
      } else if (e.keyCode === 39) { // Right arrow key
        currentIndex = (currentIndex + 1) % itemCount;
        showItem(currentIndex);
      } else if (e.keyCode === 27) { // Esc key
        closeLightbox();
      }
    }
  });
});

/*
 * FAQs Dropdown
 */
const faqQuestions = document.querySelectorAll('.faq-question');

for (let i = 0; i < faqQuestions.length; i++) {
  faqQuestions[i].addEventListener('click', function() {
    const faqBlock = this.parentElement;

    if (faqBlock.classList.contains('active')) {
      faqBlock.classList.remove('active');
    } else {
      faqBlock.classList.add('active');
    }
  });
}

/*
 * Product feature carousel
 */
function createImageCarousel(intervalDuration) {
  const overlayDiv = document.querySelector('.feature-carousel .featured-image-block .overlay-div');
  const textBlocks = document.querySelectorAll('.carousel-text .text-block');
  const imageBlocks = document.querySelectorAll('.feature-carousel .featured-image-block .carousel-image-block');
  const progressBars = document.querySelectorAll('.progress-bar');

  let currentIndex = 0;
  let animationStartTime = null;
  let userInteracted = false;

  function updateCarousel(timestamp) {
    if (!animationStartTime) {
      animationStartTime = timestamp;
    }

    const elapsedTime = timestamp - animationStartTime;
    const progress = (elapsedTime / intervalDuration) * 100;

    if (!userInteracted) {
      progressBars[currentIndex].style.width = `${progress}%`;
    }

    if (progress >= 100 && !userInteracted) {
      animationStartTime = timestamp;
      textBlocks[currentIndex].classList.remove('active');
      imageBlocks[currentIndex].classList.remove('active');
      progressBars[currentIndex].style.width = '0';

      currentIndex = (currentIndex + 1) % imageBlocks.length;

      textBlocks[currentIndex].classList.add('active');
      imageBlocks[currentIndex].classList.add('active');
    }

    requestAnimationFrame(updateCarousel);
  }

  textBlocks[currentIndex].classList.add('active');
  imageBlocks[currentIndex].classList.add('active');

  if(overlayDiv) {
    overlayDiv.addEventListener('click', () => {
      userInteracted = true;
      textBlocks[currentIndex].classList.add('user-stop');
      imageBlocks[currentIndex].classList.add('active', 'user-interacted');

      document.querySelectorAll('.feature-carousel .carousel-image-block').forEach(videoWrap => {
        videoWrap.classList.add('user-interacted');
      });

      // Remove overlay-div from all instances
      document.querySelectorAll('.overlay-div').forEach(div => {
        div.remove();
      });
    });
  }

  textBlocks.forEach((textBlock, index) => {
    textBlock.addEventListener('click', () => {
      userInteracted = true;
      progressBars[currentIndex].style.width = '0';
      textBlocks[currentIndex].classList.remove('active', 'user-stop');
      imageBlocks[currentIndex].classList.remove('active', 'user-interacted');

      document.querySelectorAll('.feature-carousel .carousel-image-block').forEach(videoWrap => {
        videoWrap.classList.remove('user-interacted');
      });

      currentIndex = index;
      textBlocks[currentIndex].classList.add('active', 'user-stop');
      imageBlocks[currentIndex].classList.add('active', 'user-interacted');

      const videoWrap = imageBlocks[currentIndex].querySelector('.feature-carousel .carousel-image-block');
      if (videoWrap) {
        videoWrap.classList.add('user-interacted');
      }
    });
  });

  requestAnimationFrame(updateCarousel);
}

/*
 * Pricing toggle switch
 */
function setupPricingToggle() {
  const switchInputs = document.querySelectorAll(".price-toggle-switch .switch-wrapper input");
  const prices = document.querySelectorAll(".price");
  const toggleClass = "hide";

  for (const switchInput of switchInputs) {
    switchInput.addEventListener("input", function () {
      // console.log("Input event triggered");

      for (const price of prices) {
        price.classList.add(toggleClass);
      }

      const activePrices = document.querySelectorAll(`.price.${switchInput.id}`);
      // console.log("Active prices:", activePrices);

      for (const activePrice of activePrices) {
        activePrice.classList.remove(toggleClass);
      }
    });
  }
}

/*
 * Terms of Service toggle switch
 */
function setupTermsToggle() {
  const switchInputs = document.querySelectorAll(".terms-toggle-switch .switch-wrapper input");
  const terms = document.querySelectorAll(".terms-toggle");
  const toggleClass = "hide";

  for (const switchInput of switchInputs) {
    switchInput.addEventListener("input", function () {
      // console.log("Input event triggered");

      for (const term of terms) {
        term.classList.add(toggleClass);
      }

      const activeTerms = document.querySelectorAll(`.terms-toggle.${switchInput.id}`);
      // console.log("Active terms:", activeTerms);

      for (const activeTerm of activeTerms) {
        activeTerm.classList.remove(toggleClass);
      }
    });
  }
}
setupTermsToggle();